import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { AppNavigation } from "~/components/app/shared/navigation/app-navigation";
import { useAuthContext } from "~/contexts/auth-context";

export const Route = createFileRoute("/legal")({
  component: LegalLayout,
});

function LegalLayout() {


  return (
    <div className="flex h-screen flex-col">
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
